import {StyleSheet} from "aphrodite";
import * as React from "react";

import {ActionItem, ActionMenu} from "@khanacademy/wonder-blocks-dropdown";
import type {PhosphorIconAsset} from "@khanacademy/wonder-blocks-icon";
import IconButton from "@khanacademy/wonder-blocks-icon-button";

interface ToolAction {
    label: string;
    onClick: () => any;
}

export default function ToolButton(props: {
    icon: PhosphorIconAsset;
    tooltip: string;
    active?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    actions?: ToolAction[];
}): React.ReactElement {
    const button = (
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props -- TODO: Address a11y error
        <IconButton
            onClick={props.onClick}
            aria-label={props.tooltip}
            aria-pressed={props.active}
            role="menuitem"
            icon={props.icon}
            kind={props.active ? "primary" : "tertiary"}
            actionType={props.active ? "progressive" : "neutral"}
            disabled={props.disabled}
            style={styles.button}
        />
    );

    if (props.actions && props.actions.length) {
        return (
            <ActionMenu
                opener={() => button}
                menuText={props.tooltip}
                disabled={props.disabled}
                alignment="right"
            >
                {props.actions.map((a, i) => (
                    <ActionItem key={i} label={a.label} onClick={a.onClick} />
                ))}
            </ActionMenu>
        );
    }

    return button;
}

const styles = StyleSheet.create({
    button: {
        transform: "scale(0.8) !important",
        flexShrink: 0,
        flexGrow: 0,
    },
});
